import { FC, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import EfImg from '@elem/ui/ef-img';
import styled from './Dialog.module.scss';
import IconClose from '@/components/MembersDay/FY2024/Teaser/ReferralNext/IconClose';
import IconTop1 from '@/components/MembersDay/FY2024/Teaser/ReferralNext/IconTop1';
import IconTop2 from '@/components/MembersDay/FY2024/Teaser/ReferralNext/IconTop2';
import IconTop3 from '@/components/MembersDay/FY2024/Teaser/ReferralNext/IconTop3';
import { useLang } from '@/app/utils/useLang';
import { getCurrentPlanTop } from '@/service/referral';
import getLocal from '@/app/utils/getLocal';

interface IProps {
    planId?: string;
    callback?: any;
}

const VLBModal: FC<IProps> = ({ planId, callback }) => {
    const { t } = useLang('membersday.teaser.WinTable');
    const [isClient, setIsClient] = useState(false);
    const [tabActive] = useState('1');
    const { locale } = getLocal();
    const [listA, setListA] = useState<any[]>([]);
    const [listB, setListB] = useState<any[]>([]);

    const [isLoading, setIsLoading] = useState(false);

    const redEmailCallback = (list: any) => {
        const list2 = JSON.parse(JSON.stringify(list));
        const itemA = list2[0] || null;
        if (itemA) {
            const email1 = itemA.email || '';
            const email2 = email1.split('@');
            const name = email2[0] || email1;
            itemA.email = name;
        }
        return list2;
    };

    const initData = async () => {
        const data: { page?: number; size: number; planId: string; lastMon: number } = {
            planId: planId || '',
            size: 20,
            lastMon: 0, // 当前月份的
        };

        setIsLoading(true);
        const rankData = await getCurrentPlanTop(data, locale);
        setIsLoading(false);

        if (tabActive === '1') {
            setListA(redEmailCallback(rankData?.data?.content || []));
        } else if (tabActive === '2') {
            setListB(rankData?.data?.content || []);
        }
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (planId) {
            initData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive, planId]);

    if (!isClient) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className={`glo-editor-modal glo-editor-modal-show ${styled.WinTable}`}>
            <div className="glo-editor-modal-wrap">
                <div className="modal-content">
                    <IconClose
                        className="win-close"
                        onClick={() => {
                            callback && callback();
                        }}
                    />
                    <div className="item-img">
                        <EfImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1741505324684/gold-bg-pc.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1741505324684/gold-bg-pc.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1741505263203/gold-bg.png"
                        />
                    </div>
                    <div className="win-title">{t('title')}</div>
                    <div className="win-descTitle">{t('descTitle')}</div>
                    <div className={`tab-c-item ${tabActive === '1' ? ' tab-item-active' : ''} ${!isLoading && listA.length === 0 ? 'overflow-hidden' : ''}`}>
                        <div className={`list-table`}>
                            <div className="list-table-tr list-table-thead">
                                <div className="list-table-td">{t('td1')}</div>
                                <div className="list-table-td">{t('td2')}</div>
                                <div className="list-table-td">{t('td3')}</div>
                            </div>
                            {!isLoading &&
                                listA.length > 0 &&
                                listA.map((item: any, index: number) => {
                                    return (
                                        <div className={`list-table-tr ${item.userId && 'active'}`} key={index}>
                                            <div className="list-table-td">
                                                <span className={`list-table-index list-table-index-${index + 1}`}>
                                                    {item.ranking === 1 && <IconTop1 />}
                                                    {item.ranking === 2 && <IconTop2 />}
                                                    {item.ranking === 3 && <IconTop3 />}
                                                    {item.ranking > 3 && <>{item.ranking || '-'}</>}
                                                </span>
                                            </div>
                                            <div className="list-table-td">{item.email}</div>
                                            <div className="list-table-td">{item.registerCount}</div>
                                        </div>
                                    );
                                })}

                            {!isLoading && listA.length === 0 && <div className="list-table-empty"></div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body,
    );
};

export default VLBModal;
